export const toTitleCase = (str) => {
  return str
    // ?.toLowerCase()
    // ?.split(" ")
    // ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    // ?.join(" ");
};

export const toTitleCaseRequired = (str) => {
  return str
    ?.toLowerCase()
    ?.split(" ")
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    ?.join(" ");
};


export const prepareEmailBody = (htmlBody, attachments) => {
  if (!htmlBody) return "";
  if (!attachments || attachments.length === 0) return htmlBody;

  let processedHtml = htmlBody;

  attachments.forEach((attachment) => {
    // Only target inline attachments containing a valid contentId and raw bytes
    if (attachment.isInline && attachment.contentId && attachment.contentBytes) {
      const cidUrl = `cid:${attachment.contentId}`;

      // Determine correct mime type image format extension safely
      const contentType = attachment.contentType || 'image/png';
      const base64DataUrl = `data:${contentType};base64,${attachment.contentBytes}`;

      // Replace all instances of this specific cid string globally inside the HTML
      processedHtml = processedHtml.split(cidUrl).join(base64DataUrl);
    }
  });

  return processedHtml;
};


export const resolveInlineImages = (htmlBody, attachments = []) => {
  if (!htmlBody) return "";
  if (!attachments || attachments.length === 0) return htmlBody;

  let processedHtml = htmlBody;

  // 1. Matches all instances of src="cid:..." or src='cid:...'
  const cidRegex = /src=["']cid:([^"']+)["']/gi;
  let match;

  // 2. Extract all images out of your attachments array
  const imageAttachments = attachments.filter(att =>
    att.contentType && att.contentType.startsWith("image/")
  );

  let imageIndex = 0;

  while ((match = cidRegex.exec(htmlBody)) !== null) {
    const fullCidString = match[1]; // e.g., "bdd6438e-df11-4b63-a671-c550d0be2c65"

    // Attempt A: Match by explicit contentId if it exists
    let foundAttachment = attachments.find(att =>
      att.contentId && att.contentId.toLowerCase() === fullCidString.toLowerCase()
    );

    // Attempt B: Fallback index matching (since Microsoft strips Content-ID for certain signatures)
    if (!foundAttachment && imageAttachments[imageIndex]) {
      foundAttachment = imageAttachments[imageIndex];
      imageIndex++; // Increment for subsequent broken signature assets if present
    }

    if (foundAttachment && foundAttachment.contentBytes) {
      const mimeType = foundAttachment.contentType || "image/png";
      const base64DataUrl = `data:${mimeType};base64,${foundAttachment.contentBytes}`;

      // Swap out the cid token directly with the base64 URI
      processedHtml = processedHtml.split(`cid:${fullCidString}`).join(base64DataUrl);
    }
  }

  return processedHtml;
};